import { defineStore } from "pinia";
import { apiRequest } from "@/api";
import { ENDPOINTS } from "@/api/endpoints";
import { notification$ } from "../tech";
import type { IUser, IUsersStore } from "./users.types";

export const useUsersStore = defineStore("users", {
  state: (): IUsersStore => {
    return {
      getCurrentUserControllers: [],
      getUsersControllers: [],
      currentUser: null,
      users: [],
    };
  },
  getters: {
    getUsersLoading: (state) => {
      return state.getUsersControllers.length > 0;
    },
    getCurrentUserLoading: (state) => {
      return state.getCurrentUserControllers.length > 0;
    },
  },
  actions: {
    async getCurrentUser() {
      this.getCurrentUserControllers.forEach((c) => c.abort());
      const controller = new AbortController();
      this.getCurrentUserControllers.push(controller);

      const [user, error] = await apiRequest<IUser>({
        method: "GET",
        path: ENDPOINTS.getCurrentUser,
        refetchAfterAuth: undefined,
      });

      if (!error) {
        this.currentUser = user;
      }

      this.getCurrentUserControllers = this.getCurrentUserControllers.filter(
        (c) => c !== controller,
      );

      return !error;
    },
    async getUsers() {
      this.getUsersControllers.forEach((c) => c.abort());
      const controller = new AbortController();
      this.getUsersControllers.push(controller);

      const [users, error] = await apiRequest<IUser[]>({
        method: "GET",
        path: ENDPOINTS.getUsers,
        onError: (type) => {
          if (type === "abort") return;
          notification$.next({
            text: "Не удалось получить список пользователей",
            title: "Получение списка пользователей",
          });
        },
      });

      if (error) {
        this.users = [];
      } else {
        this.users = users;
      }

      this.getUsersControllers = this.getUsersControllers.filter((c) => c !== controller);
    },
  },
});
